<template>
	<div>
		<div class="w-full mb-5 flex justify-between">
			<h1 class="text-3xl font-black text-dbBlue">
				My Profile
			</h1>
		</div>
		<div class="grid grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
			<div class="card col-span-2 lg:col-span-1">
				<div class="px-4 py-5 sm:px-6 bg-white relative overflow-hidden">
					<h2 class="card-heading">
						Contact Information
					</h2>
					<card-header-backdrop class="opacity-30" />
				</div>
				<div class="px-4 py-5 sm:p-6">
					<p class="font-bold">
						{{ firstName + " " + lastName }}
					</p>
					<p>{{ email }}</p>
					<p>{{ phones }}</p>
				</div>
			</div>
			<div class="card col-span-2 lg:col-span-1">
				<div class="px-4 py-5 sm:px-6 bg-white relative overflow-hidden">
					<h2 class="card-heading">
						Company Information
					</h2>
					<card-header-backdrop class="opacity-30" />
				</div>
				<div class="px-4 py-5 sm:p-6">
					<p class="font-bold">
						{{ company }}
					</p>
					<div>
						<p>{{ address1 }}</p>
						<p v-if="address2">
							{{ address2 }}
						</p>
						<p>
							{{ [[city, state].filter(Boolean).join(", "), zip].filter(Boolean).join(" ") }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	export default { name: 'MyProfile' } // name the component
</script>

<script setup lang="ts">
	// store
	import {
		store as useStore
	} from "@/store/user"

	// vue
	import {
		ref
	} from 'vue'

	const store = useStore()
	const firstName = ref(store.user.cognitoUser.attributes.given_name)
	const lastName = ref(store.user.cognitoUser.attributes.family_name)
	// const phones = store.user.phoneNumbers
	const phones = ref("")
	const email = ref(store.user.cognitoUser.attributes.email)
	const company = ref(store.user.cognitoUser.attributes["custom:company"])
	const address1 = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").street_address.split("\n")[0])
	const address2 = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").street_address.split("\n")[1])
	const city = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").locality)
	const state = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").region)
	const zip = ref(JSON.parse(store?.user?.cognitoUser?.attributes?.address || "{}").postal_code)
</script>
